module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/is-pure.js
// module id = 26
// module chunks = 1